import { render, staticRenderFns } from "./r-trader-offer-dialog.vue?vue&type=template&id=0c255937&scoped=true"
import script from "./r-trader-offer-dialog.vue?vue&type=script&lang=js"
export * from "./r-trader-offer-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-trader-offer-dialog.vue?vue&type=style&index=0&id=0c255937&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c255937",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c255937')) {
      api.createRecord('0c255937', component.options)
    } else {
      api.reload('0c255937', component.options)
    }
    module.hot.accept("./r-trader-offer-dialog.vue?vue&type=template&id=0c255937&scoped=true", function () {
      api.rerender('0c255937', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-offer-dialog.vue"
export default component.exports